export function modeTxt (type) {
  switch (type) {
    case 'productKey':
      return 'productKey'

    case 'productSecret':
      return 'productSecret'

    case 'productName':
      return '产品名称'

    case 'categoryName':
      return '所属品类'

    case 'nodeType':
      return '节点类型'

    case 'connectionType':
      return '连网方式'

    case 'dataFormat':
      return '数据格式'

    case 'authType':
      return '认证方式'

    case 'productDescription':
      return '产品描述'

    case 'productStatus':
      return '产品状态'

    case 'deviceNum':
      return '设备数'

    case 'createTime':
      return '创建时间'

    case 'updateTime':
      return '更新时间'

    default:
      return ''
  }
}

export function modeTxt2 (type) {
  switch (type) {
    case 'productBrand':
      return '产品品牌'

    case 'accessType':
      return '接入类型'

    case 'productModel':
      return '产品型号'

    case 'groupSign':
      return '分组标签'

    case 'alias':
      return '产品别名'

    case 'customerPhone':
      return '客服电话'

    case 'manufacturerName':
      return '制造商'

    case 'vendorPhone':
      return '供应商电话'

    case 'agreementFile':
      return '协议文件'

    case 'configNet':
      return '配网方式'
    default:
      return ''
  }
}
